import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import YearlyStatementChild from "./YearlyStatementChild";

const YearlyStatement = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <YearlyStatementChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default YearlyStatement;
